import React from 'react';

export default function Footer() {
  return (
    <div className="relative mt-10 bg-customBlue">
      <svg
        className="absolute top-0 w-full h-6 -mt-5 sm:-mt-10 sm:h-16 text-customBlue"
        preserveAspectRatio="none"
        viewBox="0 0 1440 54"
      >
        <path
          fill="currentColor"
          d="M0 22L120 16.7C240 11 480 1.00001 720 0.700012C960 1.00001 1200 11 1320 16.7L1440 22V54H1320C1200 54 960 54 720 54C480 54 240 54 120 54H0V22Z"
        />
      </svg>
      <div className="px-4 pt-12 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="grid gap-x-12 mb-8 lg:grid-cols-4 text-center">
          {/* Columna 1 */}
          <div>
            <span className="flex flex-row items-center justify-center gap-2">
              {/* ...logo y nombre... */}
              <svg
                className="w-6 sm:w-8 text-gray-100"
                viewBox="0 0 24 24"
                strokeLinejoin="round"
                strokeWidth="2"
                strokeLinecap="round"
                strokeMiterlimit="10"
                stroke="currentColor"
                fill="none"
              >
                <rect x="3" y="1" width="7" height="12" />
                <rect x="3" y="17" width="7" height="6" />
                <rect x="14" y="1" width="7" height="6" />
                <rect x="14" y="11" width="7" height="12" />
              </svg>
              <span className="text-md md:text-xl font-bold font-heading tracking-wide text-gray-100 uppercase">
                Sol Naciente
              </span>
            </span>
            <div className="mt-4 lg:max-w-sm mx-auto">
              <p className="text-sm md:text-base tracking-wide text-gray-100">
                Somos una inmobiliaria ubicada en el Oriente Antioqueño. Tenemos
                inmuebles para la venta y arrendamiento. A parte, contamos con
                un grupo de Profesionales para brindarles la mejor asesoría.
              </p>
            </div>
          </div>
          {/* Columna 2: Información de contacto y Horario de atención */}
          <div className="grid mt-2 lg:mt-0 grid-cols-2 lg:grid-cols-1 gap-4 lg:gap-0">
            <div className="pt-6 lg:pt-0 pb-6 lg:pb-0">
              <p className="text-sm md:text-base font-bold font-heading tracking-wide text-gray-100 uppercase">
                Información de Contacto
              </p>
              <ul className="mt-2 space-y-2">
                {/* ...teléfonos... */}
                <li>
                  <div className="md:max-w-md lg:col-span-2 mx-auto flex items-center justify-center">
                    {/* ...svg... */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="22"
                      height="22"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#fff"
                        d="M4.9,43.3l2.7-9.8C5.9,30.6,5,27.3,5,24C5,13.5,13.5,5,24,5c5.1,0,9.8,2,13.4,5.6	C41,14.2,43,18.9,43,24c0,10.5-8.5,19-19,19c0,0,0,0,0,0h0c-3.2,0-6.3-0.8-9.1-2.3L4.9,43.3z"
                      ></path>
                      <path
                        fill="#fff"
                        d="M4.9,43.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.3-0.1-0.5L7,33.5c-1.6-2.9-2.5-6.2-2.5-9.6	C4.5,13.2,13.3,4.5,24,4.5c5.2,0,10.1,2,13.8,5.7c3.7,3.7,5.7,8.6,5.7,13.8c0,10.7-8.7,19.5-19.5,19.5c-3.2,0-6.3-0.8-9.1-2.3L5,43.8C5,43.8,4.9,43.8,4.9,43.8z"
                      ></path>
                      <path
                        fill="#cfd8dc"
                        d="M24,5c5.1,0,9.8,2,13.4,5.6C41,14.2,43,18.9,43,24c0,10.5-8.5,19-19,19h0c-3.2,0-6.3-0.8-9.1-2.3	L4.9,43.3l2.7-9.8C5.9,30.6,5,27.3,5,24C5,13.5,13.5,5,24,5 M24,43L24,43L24,43 M24,43L24,43L24,43 M24,4L24,4C13,4,4,13,4,24	c0,3.4,0.8,6.7,2.5,9.6L3.9,43c-0.1,0.3,0,0.7,0.3,1c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0l9.7-2.5c2.8,1.5,6,2.2,9.2,2.2	c11,0,20-9,20-20c0-5.3-2.1-10.4-5.8-14.1C34.4,6.1,29.4,4,24,4L24,4z"
                      ></path>
                      <path
                        fill="#40c351"
                        d="M35.2,12.8c-3-3-6.9-4.6-11.2-4.6C15.3,8.2,8.2,15.3,8.2,24c0,3,0.8,5.9,2.4,8.4L11,33l-1.6,5.8	l6-1.6l0.6,0.3c2.4,1.4,5.2,2.2,8,2.2h0c8.7,0,15.8-7.1,15.8-15.8C39.8,19.8,38.2,15.8,35.2,12.8z"
                      ></path>
                      <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M19.3,16c-0.4-0.8-0.7-0.8-1.1-0.8c-0.3,0-0.6,0-0.9,0	s-0.8,0.1-1.3,0.6c-0.4,0.5-1.7,1.6-1.7,4s1.7,4.6,1.9,4.9s3.3,5.3,8.1,7.2c4,1.6,4.8,1.3,5.7,1.2c0.9-0.1,2.8-1.1,3.2-2.3	c0.4-1.1,0.4-2.1,0.3-2.3c-0.1-0.2-0.4-0.3-0.9-0.6s-2.8-1.4-3.2-1.5c-0.4-0.2-0.8-0.2-1.1,0.2c-0.3,0.5-1.2,1.5-1.5,1.9	c-0.3,0.3-0.6,0.4-1,0.1c-0.5-0.2-2-0.7-3.8-2.4c-1.4-1.3-2.4-2.8-2.6-3.3c-0.3-0.5,0-0.7,0.2-1c0.2-0.2,0.5-0.6,0.7-0.8	c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.3,0.1-0.6,0-0.8C20.6,19.3,19.7,17,19.3,16z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="ml-2 text-sm tracking-wide text-gray-100 uppercase">
                      (+57) 314 874 3384
                    </span>
                  </div>
                </li>
                <li>
                  <div className="mx-auto flex items-center justify-center">
                    {/* ...svg... */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="22"
                      height="22"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#fff"
                        d="M4.9,43.3l2.7-9.8C5.9,30.6,5,27.3,5,24C5,13.5,13.5,5,24,5c5.1,0,9.8,2,13.4,5.6	C41,14.2,43,18.9,43,24c0,10.5-8.5,19-19,19h0c-3.2,0-6.3-0.8-9.1-2.3L4.9,43.3z"
                      ></path>
                      <path
                        fill="#fff"
                        d="M4.9,43.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.3-0.1-0.5L7,33.5c-1.6-2.9-2.5-6.2-2.5-9.6	C4.5,13.2,13.3,4.5,24,4.5c5.2,0,10.1,2,13.8,5.7c3.7,3.7,5.7,8.6,5.7,13.8c0,10.7-8.7,19.5-19.5,19.5c-3.2,0-6.3-0.8-9.1-2.3L5,43.8C5,43.8,4.9,43.8,4.9,43.8z"
                      ></path>
                      <path
                        fill="#cfd8dc"
                        d="M24,5c5.1,0,9.8,2,13.4,5.6C41,14.2,43,18.9,43,24c0,10.5-8.5,19-19,19h0c-3.2,0-6.3-0.8-9.1-2.3	L4.9,43.3l2.7-9.8C5.9,30.6,5,27.3,5,24C5,13.5,13.5,5,24,5 M24,43L24,43L24,43 M24,43L24,43L24,43 M24,4L24,4C13,4,4,13,4,24	c0,3.4,0.8,6.7,2.5,9.6L3.9,43c-0.1,0.3,0,0.7,0.3,1c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0l9.7-2.5c2.8,1.5,6,2.2,9.2,2.2	c11,0,20-9,20-20c0-5.3-2.1-10.4-5.8-14.1C34.4,6.1,29.4,4,24,4L24,4z"
                      ></path>
                      <path
                        fill="#40c351"
                        d="M35.2,12.8c-3-3-6.9-4.6-11.2-4.6C15.3,8.2,8.2,15.3,8.2,24c0,3,0.8,5.9,2.4,8.4L11,33l-1.6,5.8	l6-1.6l0.6,0.3c2.4,1.4,5.2,2.2,8,2.2h0c8.7,0,15.8-7.1,15.8-15.8C39.8,19.8,38.2,15.8,35.2,12.8z"
                      ></path>
                      <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M19.3,16c-0.4-0.8-0.7-0.8-1.1-0.8c-0.3,0-0.6,0-0.9,0	s-0.8,0.1-1.3,0.6c-0.4,0.5-1.7,1.6-1.7,4s1.7,4.6,1.9,4.9s3.3,5.3,8.1,7.2c4,1.6,4.8,1.3,5.7,1.2c0.9-0.1,2.8-1.1,3.2-2.3	c0.4-1.1,0.4-2.1,0.3-2.3c-0.1-0.2-0.4-0.3-0.9-0.6s-2.8-1.4-3.2-1.5c-0.4-0.2-0.8-0.2-1.1,0.2c-0.3,0.5-1.2,1.5-1.5,1.9	c-0.3,0.3-0.6,0.4-1,0.1c-0.5-0.2-2-0.7-3.8-2.4c-1.4-1.3-2.4-2.8-2.6-3.3c-0.3-0.5,0-0.7,0.2-1c0.2-0.2,0.5-0.6,0.7-0.8	c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.3,0.1-0.6,0-0.8C20.6,19.3,19.7,17,19.3,16z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="ml-2 text-sm tracking-wide text-gray-100 uppercase">
                      (+57) 310 460 5323
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="mt-6 lg:mt-4 mb-6 lg:mb-0">
              <p className="text-sm md:text-base font-bold font-heading tracking-wide text-gray-100 uppercase">
                Horario de atención
              </p>
              <ul className="mt-2 space-y-2">
                <li>
                  <div className="mt-2 lg:max-w-sm mx-auto flex items-center justify-center">
                    <p className="text-sm tracking-wide text-gray-100">
                      Lunes - Viernes
                    </p>
                  </div>
                </li>
                <li>
                  <div className="md:max-w-md lg:col-span-2 mx-auto flex items-center justify-center">
                    {/* ...svg... */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="22"
                      height="22"
                      viewBox="0 0 100 100"
                    >
                      <circle cx="52" cy="52" r="44" opacity=".35"></circle>
                      <circle cx="50" cy="50" r="44" fill="#f2f2f2"></circle>
                      <path
                        fill="#f2f2f2"
                        d="M50,91C27.393,91,9,72.607,9,50S27.393,9,50,9s41,18.393,41,41S72.607,91,50,91z"
                      ></path>
                      <circle
                        cx="50"
                        cy="50"
                        r="38.026"
                        fill="#70bfff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="30.026"
                        fill="#d9eeff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="37.5"
                        fill="none"
                        stroke="#40396e"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                      ></circle>
                      <circle cx="26" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="74" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="26" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="74" r="2" fill="#707cc0"></circle>
                      <polyline
                        fill="none"
                        stroke="#40396e"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        points="64.5,30.5 49.5,50 62,63"
                      ></polyline>
                      <circle cx="50" cy="50" r="4" fill="#40396e"></circle>
                    </svg>
                    <span className="ml-2 text-sm tracking-wide text-gray-100">
                      8:00 am - 1:00 pm
                    </span>
                  </div>
                  <div className="md:max-w-md mt-2 lg:col-span-2 mx-auto flex items-center justify-center">
                    {/* ...svg... */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="22"
                      height="22"
                      viewBox="0 0 100 100"
                    >
                      <circle cx="52" cy="52" r="44" opacity=".35"></circle>
                      <circle cx="50" cy="50" r="44" fill="#f2f2f2"></circle>
                      <path
                        fill="#f2f2f2"
                        d="M50,91C27.393,91,9,72.607,9,50S27.393,9,50,9s41,18.393,41,41S72.607,91,50,91z"
                      ></path>
                      <circle
                        cx="50"
                        cy="50"
                        r="38.026"
                        fill="#70bfff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="30.026"
                        fill="#d9eeff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="37.5"
                        fill="none"
                        stroke="#40396e"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                      ></circle>
                      <circle cx="26" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="74" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="26" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="74" r="2" fill="#707cc0"></circle>
                      <polyline
                        fill="none"
                        stroke="#40396e"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        points="64.5,30.5 49.5,50 62,63"
                      ></polyline>
                      <circle cx="50" cy="50" r="4" fill="#40396e"></circle>
                    </svg>
                    <span className="ml-2 text-sm tracking-wide text-gray-100">
                      2:00 pm - 5:00 pm
                    </span>
                  </div>
                </li>
                <li>
                  <div className="mt-2 lg:max-w-sm mx-auto flex items-center justify-center">
                    <p className="text-sm tracking-wide text-gray-100">
                      Sábados
                    </p>
                  </div>
                </li>
                <li>
                  <div className="md:max-w-md lg:col-span-2 mx-auto flex items-center justify-center">
                    {/* ...svg... */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="22"
                      height="22"
                      viewBox="0 0 100 100"
                    >
                      <circle cx="52" cy="52" r="44" opacity=".35"></circle>
                      <circle cx="50" cy="50" r="44" fill="#f2f2f2"></circle>
                      <path
                        fill="#f2f2f2"
                        d="M50,91C27.393,91,9,72.607,9,50S27.393,9,50,9s41,18.393,41,41S72.607,91,50,91z"
                      ></path>
                      <circle
                        cx="50"
                        cy="50"
                        r="38.026"
                        fill="#70bfff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="30.026"
                        fill="#d9eeff"
                      ></circle>
                      <circle
                        cx="50"
                        cy="50"
                        r="37.5"
                        fill="none"
                        stroke="#40396e"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                      ></circle>
                      <circle cx="26" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="74" cy="50" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="26" r="2" fill="#707cc0"></circle>
                      <circle cx="50" cy="74" r="2" fill="#707cc0"></circle>
                      <polyline
                        fill="none"
                        stroke="#40396e"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                        points="64.5,30.5 49.5,50 62,63"
                      ></polyline>
                      <circle cx="50" cy="50" r="4" fill="#40396e"></circle>
                    </svg>
                    <span className="ml-2 text-sm tracking-wide text-gray-100">
                      8:00 am - 1:00 pm
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {/* Columna 3: Mapa */}
          <div className="lg:col-span-2 mt-2 lg:mt-0 rounded shadow-3xl flex justify-center items-center">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d247.9853420622718!2d-75.43436548410773!3d6.026895311643451!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e469752446c6713%3A0xdc47b05ccc1b6996!2sSOL%20NACIENTE!5e0!3m2!1ses-419!2sco!4v1721798627827!5m2!1ses-419!2sco"
              title="Google maps location"
              className="w-full h-full rounded border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
        {/* Texto Developed by SoftMinds */}
        <div className="flex justify-center items-center pt-5 pb-10 relative">
          <div
            className="absolute top-0 left-0 h-px bg-deep-purple-accent-200"
            style={{ borderTopWidth: '1px', width: '100%' }}
          />
          <div
            className="relative inline-block overflow-hidden w-full"
            style={{ isolation: 'isolate' }}
          >
            <img
              src="/GenMindsLogo.png"
              alt="GenMinds"
              className="h-14 mx-auto my-2 relative z-10 object-contain"
            />
            <p className="text-xs text-white font-medium text-center italic relative z-10 m-0">
              Copyright © 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
